import React, { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { retrocederEtapaAPI } from '../../../consumers/backendApisUrls';

// Confirmación antes de retroceder la etapa de un postulante (GDH, etapa
// Revisión Inicial + estado No apto). Mismo patrón que
// ConfirmarEnvioComunicacionResultado.jsx: el modal resuelve el POST y avisa
// a la bandeja para que refresque el listado al terminar.
const ConfirmarRetrocederEtapaModal = ({ toggleModal, refreshPage, postulante = {} }) => {
    const [managePostRequest] = useManagePostRequest();
    const [isSending, setIsSending] = useState(false);
    // Candado síncrono: el estado isSending se actualiza de forma asíncrona,
    // así que un doble clic rápido podría disparar el POST dos veces antes del
    // re-render. El ref se marca antes del primer await para evitarlo.
    const confirmandoRef = useRef(false);
    // Nombre completo del postulante (lo arma la bandeja con row.nombrePostulante).
    const nombrePostulante = postulante?.nombrePostulante ?? '';

    const handleConfirmar = async () => {
        if (!postulante?.idPostulante || confirmandoRef.current) return;
        confirmandoRef.current = true;
        setIsSending(true);
        const payload = {
            IdPostulante: postulante.idPostulante,
            IdEtapaActual: postulante.idEtapa,
        };
        await managePostRequest(
            retrocederEtapaAPI(),
            payload,
            async () => {
                toast.success('La etapa se retrocedió correctamente');
                if (refreshPage) await refreshPage();
                toggleModal();
            },
            false,
            () => {
                // Ante error el modal sigue abierto: se habilita de nuevo para
                // permitir un reintento.
                confirmandoRef.current = false;
                setIsSending(false);
            }
        );
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Retroceder Etapa" width="480px">
            <div className="modal-body">
                <p className="mb-0">
                    ¿Confirma que desea retroceder la etapa{nombrePostulante ? ` para ${nombrePostulante}` : ''}?
                </p>
            </div>
            <div className="modal-footer justify-content-end">
                <button type="button"
                        className="btn btn-outline-secondary mr-2"
                        disabled={isSending}
                        onClick={toggleModal}>
                    Cancelar
                </button>
                <button type="button"
                        className="btn generic-button-buscador generic-button-hover-rojo"
                        disabled={isSending}
                        onClick={handleConfirmar}>
                    Confirmar
                </button>
            </div>
        </GenericModal>
    );
};

export default ConfirmarRetrocederEtapaModal;
